import React, { useEffect, useState } from "react";
import { graphql } from "react-apollo";
import MUIDataTable from "mui-datatables";
import { Grid } from "@material-ui/core";

import DrawerPlacements from "../../../../components/DrawerPlacements";
import PageError from "../../../../components/PageError";
import PageLoading from "../../../../components/PageLoading";
import PageTitle from "../../../../components/PageTitle/PageTitle";
import AddAdUnits from "../../actions/create";
import { AdUnitList } from "../../actions/list";
import { FIND_ADUNITS_DOMAINS } from "../../../../queries/adUnit";

export const DomainsList = ({
  data: { findAdUnitsDomains, loading, error },
}) => {
  const [publisherIds, setPublisherIds] = useState([]);
  useEffect(() => {
    async function fetchSitesData() {
      const response = await fetch("https://api-staging.adireto.com/graphql", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("id_token")}`,
        },
        body: JSON.stringify({
          query: `query {
          sites{
            domain
            publisherId
          }
        }`,
        }),
      });
      const {
        data: { sites },
      } = await response.json();
      setPublisherIds(sites);
    }
    fetchSitesData();
  }, []);

  const columns = [
    {
      name: "domain",
    },
    {
      name: "publisherId",
    },
    {
      label: "Actions",
      name: "actions",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return actionsDomains(tableMeta);
        },
        empty: true,
        filter: false,
        sort: false,
      },
    },
  ];

  const actionsDomains = tableMeta => {
    const publisherId = tableMeta.rowData[1];
    return (
      <>
        <AdUnitList publisherId={publisherId} publisherIds={publisherIds} />
      </>
    );
  };

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <PageTitle title="Ad Units" />
        </Grid>
        <Grid item xs={2}>
          <DrawerPlacements title="Ad Unit" labeButtonAction="Add">
            <AddAdUnits publisherIds={publisherIds}></AddAdUnits>
          </DrawerPlacements>
        </Grid>
      </Grid>

      {loading ? (
        <PageLoading />
      ) : error ? (
        <PageError />
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <MUIDataTable
              title={false}
              data={findAdUnitsDomains}
              columns={columns}
              options={{
                selectableRows: "none",
                responsive: "scrollMaxHeight",
              }}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export const Domains = graphql(FIND_ADUNITS_DOMAINS)(DomainsList);
